<div class="bp-modal mod-lg no-separator">
	<bp-modal-header class="font-semibold" [title]="'swap_coins' | translate">
		<a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<!-- Unverified message -->
	@if (isUnverified) {
		<div class="modal-add-info mb-30">
			<h3 class="modal-add-info-headline">
				{{ "because_of_verification_you_cant_use_deposit_header" | translate }}
			</h3>
			<p class="modal-add-info-text text-narrowest center-block">
				{{ "because_of_verification_you_cant_use_swap_information" | translate }}
			</p>
			<button
				class="modal-add-info-button btn btn-primary btn-inverse btn-bold btn-bigger-text"
				tabindex="501"
				(click)="verify()"
				type="button">
				<i class="bpi__icon-verify"></i>
				{{ "start_verification_here_button" | translate }}
			</button>
		</div>
	}
	<!-- Swap modal content -->
	@if (combinedViewObservables$ | async; as combinedValues) {
		@if (isAtLeastDocumented) {
			<div class="bp-modal-body">
				<div class="bp-modal-body-section mod-secondary">
					<div class="main-container-dropdowns">
						<!-- Left dropdown -->
						<div class="container-dropdown left">
							<span class="text-above-dropdown">{{ "swap_from" | translate }}</span>
							<bp-select
								class="mb-5 main-container-dropdowns__full-width"
								[ngClass]="{ 'mod-empty': !leftSelection?.currentWallet }"
								[options]="leftSelection.bpSelectOptions"
								[useEmptyState]="true"
								[placeholder]="emptyStatePlaceHolder"
								[(selectedValue)]="leftSelection.currentWallet"
								[searchTermOnClose]="leftSelection?.currentWallet?.getName()"
								[bindLabel]="'name'"
								[searchable]="true"
								(selectedValueChange)="onDropdownValueChange($event, 'left')"
								[customSearchFn]="getCustomSearch()"></bp-select>
							<div class="wallet-total-funds">
								@if (isTradable(leftSelection.currentWallet)) {
									{{ "swap_available" | translate }}:
									<!-- Index uses default Fiat as currency -->
									@if (isIndex(leftSelection?.currentWallet)) {
										{{
											toDefaultFiat(leftSelection?.currentWallet?.getBalance())
												| fiat_precision_symbol
													: { id: defaultFiat.getId(), currencies: [defaultFiat] }
										}}
									} @else {
										{{
											leftSelection?.currentWallet?.getBalance()
												| tradable_precision_symbol
													: {
															id: leftSelection?.currentWallet?.getCurrencyId(),
															ignorePrecision: true
													  }
										}}
									}
									<!-- Regular currency -->
								}
							</div>
						</div>
						<div class="vertical-line"></div>
						<!-- Right dropdown -->
						<div class="container-dropdown right">
							<div class="text-above-dropdown">{{ "swap_to" | translate }}</div>
							<bp-select
								class="mb-5 main-container-dropdowns__full-width"
								[ngClass]="{ 'mod-empty': !rightSelection?.currentWallet }"
								[(selectedValue)]="rightSelection.currentWallet"
								[options]="combinedValues?.assetList"
								[useEmptyState]="true"
								[placeholder]="emptyStatePlaceHolder"
								[searchTermOnClose]="getRightTradableName()"
								[bindLabel]="'name'"
								[searchable]="true"
								(selectedValueChange)="onDropdownValueChange($event, 'right')"
								[customSearchFn]="getCustomSearch()"
								(searchOutput)="searchListUpdate($event)"
								(scrollToEnd)="fetchListUpdate()"
								[isLoading]="combinedValues?.isLoading"></bp-select>
							@if (!!rightSelection?.currentWallet) {
								<div class="wallet-total-funds mod-right">
									{{
										"swap_amount_owned"
											| translate
												: [
														totalAssetAmount
															| tradable_precision_symbol
																: { id: rightSelection?.currentWallet?.getCurrencyId() }
												  ]
									}}
								</div>
							}
						</div>
					</div>
				</div>
				@let VSNbenefitFF = visionBenefitFF$ | async;
				<div class="bp-modal-body-section mod-fullwidth pt-30" [ngClass]="{ 'pb-20': hasStockTerms() }">
					@if (combinedValues?.showAmountSection && combinedValues?.taxStatusLoaded) {
						<!-- Input amount -->
						<div class="items-start flex-wrap modal-internal-transfer mod-input pt-20">
							<bp-input
								class="mod-input-line"
								iconLeading="true"
								[iconUrl]="getCurrentSelectedIcon()"
								[iconUrlAltText]="'logo_alt_text' | translate"
								min="0"
								name="wallet_amount"
								(valueChange)="inputModelChange($event)"
								[type]="getInputFormat()"
								required
								autofocus
								[(value)]="amount"
								[formGroupClass]="false"
								(onFocus)="inputOnFocus($event)"
								(onFocusOut)="inputOnFocusOut($event)">
								<!-- Non switch for taxable swap -->
								@if (hideTargetSymbol$ | async) {
									<div right>
										<img src="{{ getSwitchIcon(leftSelection.currentWallet) }}" />
									</div>
								} @else {
									<a
										right
										(click)="switchCurrencies()"
										[class.cursor-default]="showBothCurrencySymbols()"
										href="javascript:">
										@if (!hasSelectedToken()) {
											<span
												[ngClass]="{
													'text-transparent font-size-13': switchedInputCurrencies,
													'text-highlight font-size-17': !switchedInputCurrencies
												}">
												{{ getSwitchCurrencySymbol(leftSelection.currentWallet) }}
											</span>
										} @else {
											<img
												src="{{ getSwitchIcon(leftSelection.currentWallet) }}"
												[class.selected-icon]="!switchedInputCurrencies" />
										}
										@if (!showBothCurrencySymbols()) {
											/
											@if (!hasSelectedToken()) {
												<span
													[ngClass]="{
														'text-transparent font-size-13': !switchedInputCurrencies,
														'text-highlight font-size-17': switchedInputCurrencies
													}">
													{{ getSwitchCurrencySymbol(rightSelection.currentWallet) }}
												</span>
											} @else {
												<img
													src="{{ getSwitchIcon(rightSelection.currentWallet) }}"
													[class.selected-icon]="switchedInputCurrencies" />
											}
										}
									</a>
								}
								<!-- Currency switcher -->
								<!-- Set Max  -->
								<div right class="justify-center text-center max-button-container">
									<button
										class="btn btn-primary btn-xs max-button"
										type="button"
										(click)="setMaxAmount()">
										{{ "swap_max" | translate }}
									</button>
								</div>
							</bp-input>
						</div>
						<!-- Slider drag & drop -->
						<div class="asset-value-slider">
							<bp-slider
								[isMatSlider]="true"
								[model]="getSliderValue()"
								[max]="100"
								[min]="0"
								[step]="1"
								[tickInterval]="25"
								(selectedChange)="sliderUpdate($event)"></bp-slider>
						</div>
						<!-- Labels: min amount + fees info -->
						<div class="bp-modal-row bp-modal-custom-margin mt-10 modal-internal-transfer mod-input">
							@if (hasInputError && this.inputChanged) {
								<div class="bp-modal-column left amount-error">
									{{
										(amountTooLow ? "limit_order_min_error" : "amount_too_high_error")
											| translate
												: [
														isIndex(currentSwitchInputSelect.currentWallet)
															? ((amountTooLow ? getMinAmount() : getMaxAmount())
																| fiat_precision_symbol
																	: {
																			id: defaultFiat.getId(),
																			txPrecision: true,
																			currencies: [defaultFiat]
																	  })
															: ((amountTooLow ? getMinAmount() : getMaxAmount())
																| tradable_precision_symbol
																	: {
																			id: currentSwitchInputSelect?.currentWallet?.getCurrencyId(),
																			txPrecision: true
																	  })
												  ]
									}}
								</div>
							} @else {
								<div class="bp-modal-column left">
									{{ "swap_min" | translate }}:
									@if (isTradable(currentSwitchInputSelect.currentWallet) && showConversionRate) {
										<!-- Index uses Fiat currency -->
										@if (isIndex(currentSwitchInputSelect.currentWallet)) {
											{{
												getMinAmount()
													| fiat_precision_symbol
														: { id: defaultFiat.getId(), currencies: [defaultFiat] }
											}}
										} @else {
											{{
												getMinAmount()
													| tradable_precision_symbol
														: {
																id: currentSwitchInputSelect?.currentWallet?.getCurrencyId(),
																txPrecision: true
														  }
											}}
										}
										<!-- Regular currency -->
									}
								</div>
							}
							<div class="bp-modal-column right text-gray">
								<!-- Percent selected from slider -->
								<div>
									{{ getSliderValue() | percent_symbol }} {{ "max_crypto_amount_swap" | translate }}
									<!-- Index uses Fiat currency -->
									@if (isIndex(leftSelection?.currentWallet)) {
										{{
											toDefaultFiat(leftSelection?.currentWallet?.getBalance())
												| fiat_precision_symbol
													: {
															id: defaultFiat.getId(),
															currencies: [defaultFiat]
													  }
										}}
									} @else {
										{{
											leftSelection?.currentWallet?.getBalance()
												| tradable_precision_symbol
													: {
															id: leftSelection?.currentWallet?.getCurrencyId(),
															currencies: [
																getWalletCurrency(leftSelection?.currentWallet)
															]
													  }
										}}
									}
									<!-- Regular currency -->
								</div>
								<!-- Text: 1 BTC ≈ 200 ETH -->
								<div class="conversion-container">
									@if (isConversionVisible()) {
										{{
											1
												| tradable_precision_symbol
													: {
															id: getWalletTradable(
																switchInputSelections[0].currentWallet
															).getId()
													  }
										}}
										@if (isToken(switchInputSelections[0].currentWallet)) {
											{{ "fma_of" | translate: null : true }}
											{{
												" " +
													getWalletTradable(switchInputSelections[0].currentWallet).getName()
											}}
										}
										@if (isTradable(switchInputSelections[1].currentWallet)) {
											&asymp;
											{{
												(offerData?.bestFeeOptIn
													? conversionRateOneUnitBfc
													: conversionRateOneUnit
												)
													| tradable_precision_symbol
														: {
																id: switchInputSelections[1].currentWallet?.getCurrencyId()
														  }
											}}
											@if (isToken(switchInputSelections[1].currentWallet)) {
												{{ "fma_of" | translate: null : true }}
												{{
													" " +
														getWalletTradable(
															switchInputSelections[1].currentWallet
														).getName()
												}}
											}
										}
									}
								</div>
							</div>
						</div>
						<!-- Instant Trade Bonus TODO: should be removed once fee benefit is added -->
						@if (!VSNbenefitFF) {
							<div>
								<instant-trade-bonus
									[step]="getItbStep()"
									[swapData]="getITBData()"></instant-trade-bonus>
							</div>
						}
						<!-- Fee Transparency -->
						@if ((feeTransparencyCryptoOnlyEnabled$ | async) && isFeeTransparent) {
							<!-- Fee transparency and new TW display-->
							<div class="collapsible-wrapper">
								<hr class="line-divider" />
								<!-- VSN toggle  -->
								@if (VSNbenefitFF && vsnFeeBenefit?.vsnFeeCollection) {
									<web3-vision-optin-toggle [vm]="vsnFeeBenefit" (onToggle)="onVSNToggle($event)" />
								}
								<!-- VSN toggle  -->
								<collapsible-container-ui (expandHandler)="trackFeeTransparency()">
									<h3 heading class="collapsible-header">
										<span>{{ "trans_fee_price_guaranteed" | translate }}</span
										><span
											><bp-icon
												size="16"
												icon="checkmark-starburst"
												theme="regular"
												class="icon"></bp-icon
										></span> </h3
									><span action class="fee-included">{{ "trans_fee_included" | translate }}</span>
									<!-- data -->
									<fee-transparency-swap-data-ui
										[sourceTradableId]="leftSelection.currentWallet?.getCurrencyId()"
										[targetTradableId]="rightSelection.currentWallet?.getCurrencyId()"
										[data]="swapFee"
										[vsnFeeCollection]="vsnFeeCollection"></fee-transparency-swap-data-ui>
								</collapsible-container-ui>
							</div>
						}
						<!-- Fee Transparency -->
						<!-- Tax Withheld -->
						@if (taxWithheld$ | async; as txObj) {
							<div class="tax-withheld-summary-wrapper">
								@if ((feeTransparencyCryptoOnlyEnabled$ | async) && txObj?.is_taxable) {
									<!-- TW display with fee transparency enabled-->
									<collapsible-container-ui>
										<h3 heading class="collapsible-header">{{ "tax_details" | translate }}</h3>
										<!-- content -->
										<!-- Tax Whitheld object is NULL(case for BCI) OR (Tax Whiheld Object is not Null and tax_amount_fiat>=0 = show blue info box variation-->
										@if (
											(txObj?.is_taxable && !txObj.tax) ||
											(+txObj?.tax?.taxAmountFiat >= 0 && txObj?.tax?.isTaxServiceAvailable)
										) {
											<tax-info-box-ui
												[text1]="'tw_possible_taxable_heading' | translate"
												[text2]="'tw_possible_taxable_detail' | translate"
												[showLink]="true"
												[linkLabel]="'more_info_tooltip_bfc' | translate"></tax-info-box-ui>
										}
										<!-- Tax Whiheld Object is not Null and is_tax_service_available": false = show offline info box orange box variation (offline)-->
										@if (txObj.tax?.isTaxServiceAvailable === false && txObj?.is_taxable) {
											<tax-info-box-ui
												[showWarning]="true"
												[text1]="'tw_warning_heading' | translate"
												[text2]="'tw_warning_message' | translate: [userFiat.getSymbol()]"
												[showLink]="true"
												[linkLabel]="'details_tx_item' | translate"></tax-info-box-ui>
										}
									</collapsible-container-ui>
								} @else {
									<!-- Legacy TaxWH UI -->
									<!-- isTaxable is TRUE and Tax Whitheld object is NULL(case for BCI) OR (Tax Whiheld Object is not Null and tax_amount_fiat>=0 = show blue info box-->
									@if (
										(txObj.is_taxable && !txObj.tax) ||
										(txObj.is_taxable &&
											+txObj.tax?.taxAmountAsset > 0 &&
											txObj.tax?.isTaxServiceAvailable)
									) {
										<tax-possible-taxable-info-legacy-ui
											[showLink]="true"></tax-possible-taxable-info-legacy-ui>
									}
									@if (txObj.tax?.isTaxServiceAvailable === false && txObj.is_taxable) {
										<tax-offline-info-legacy-ui
											[showLink]="true"
											[walletName]="'EUR'"></tax-offline-info-legacy-ui>
									}
									<div class="bottom-spacing"></div>
								}
							</div>
						}
						<!-- Info Box -->
						<ng-container *featureVisibility="featureList.STAKING_GLOBAL">
							@if (isAssetStaked$ | async) {
								<div class="pl-30 pr-30 pt-20">
									<bp-info-box>{{ "staking_trade_flow_warning_swap" | translate }}</bp-info-box>
								</div>
							}
						</ng-container>
						<!-- Sliders (bfc, terms, hodl, metals) -->
						<hr class="divider-light-fat mb-20 mt-30 mod-swap" />
						<div class="bp-modal-body-upper pt-0 mb-10">
							<!-- Swap Sliders -->
							@if (termsConditionsFeatureFlag$ | async) {
								<!-- dynamic -->
								@if (bundles$ | async; as bundles) {
									<terms-and-conditions-updates
										[bundles]="bundles"
										[tradable]="tradable"></terms-and-conditions-updates>
								} @else {
									<loading-spinner class="spinner green loader-big no-padding"></loading-spinner>
								}
							} @else {
								<swap-toggles
									[leftSelectionWallet]="leftSelection.currentWallet"
									[showAppTestWarning]="appTestTradingWarning"
									[rightSelectionWallet]="rightSelection.currentWallet"
									[apiPending]="getAPIPending()"
									[swapOfferAPIData]="getSwapOfferAPIData()">
								</swap-toggles>
							}
						</div>
					} @else {
						@if (combinedValues?.isSwapReady) {
							<loading-spinner></loading-spinner>
						} @else {
							<div class="swap__asset-selection-info" [ngClass]="{ 'mod-warning': showErrorSection() }">
								<span class="bpi__icon-info swap__asset-selection-icon"></span>
								<span class="swap__asset-selection-text">{{ fetchInfoText() | translate }}</span>
							</div>
						}
					}
					<!-- You receive / total received -->
					<div class="pl-50 pr-50">
						@if (
							VSNbenefitFF &&
							vsnFeeBenefit?.vsnFeeCollection?.globalOptIn &&
							vsnFeeBenefit?.vsnFeeCollection?.eligibleForVsn
						) {
							<!-- Fee Benefit total -->
							@if (estimateLoading) {
								<loading-spinner></loading-spinner>
							} @else {
								<vision-summary-swap-total-ui [vm]="vsnBenefitTotalVM" />
							}
							<!-- Fee Benefit total -->
						} @else {
							<!-- Total -->
							<div class="bp-modal-row font-size-24" [ngClass]="{ 'text-light': !amount }">
								<div class="bp-modal-column left mr-5">{{ "swap_you_receive" | translate }}</div>
								@if (estimateLoading) {
									<loading-spinner></loading-spinner>
								} @else {
									@if (combinedValues?.showAmountSection) {
										@if (showConversionRate) {
											<div class="bp-modal-column right break">
												@if (showApproximateOnTotal()) {
													<span class="font-size-20 font-normal">&asymp;</span>
												}
												@if (isTradable(rightSelection.currentWallet)) {
													<strong>
														<!-- Index uses Fiat currency -->
														@if (isIndex(rightSelection.currentWallet)) {
															{{
																getTotalReceived()
																	| fiat_precision_symbol
																		: {
																				id: defaultFiat.getId(),
																				currencies: [defaultFiat]
																		  }
															}}
														} @else {
															{{
																getTotalReceived()
																	| tradable_precision_symbol
																		: {
																				id: rightSelection.currentWallet.getCurrencyId(),
																				dustThreshold: 0.0001
																		  }
															}}
														}
														<!-- Regular currency -->
													</strong>
												}
											</div>
										}
									}
									<!-- Equivalent -->
									@if (combinedValues?.showAmountSection) {
										<div class="bp-modal-row font-size-15">
											<div class="bp-modal-column left text-opaque"></div>
											@if (showConversionRate && switchedInputCurrencies) {
												<div class="bp-modal-column right break color-black">
													&asymp;
													@if (isTradable(leftSelection.currentWallet)) {
														<!-- Index uses Fiat currency -->
														@if (isIndex(leftSelection.currentWallet)) {
															{{
																getTotalReceived(true)
																	| fiat_precision_symbol
																		: {
																				id: defaultFiat.getId(),
																				currencies: [defaultFiat]
																		  }
															}}
														} @else {
															{{
																getTotalReceived(true)
																	| tradable_precision_symbol
																		: {
																				id: leftSelection.currentWallet.getCurrencyId()
																		  }
															}}
														}
														<!-- Regular currency -->
													}
												</div>
											}
										</div>
									}
								}</div
							><!-- Total -->
						}
					</div>
					<!-- Button -->
					<div class="pl-30 pr-30 mt-20 text-center">
						<button
							class="btn btn-primary btn-lg btn-summary mod-amount"
							[disabled]="isButtonDisabled || acceptOfferPending || estimateLoading"
							type="button"
							(click)="confirmSwapToAPI()">
							{{ "swap_now" | translate }}
						</button>
					</div>
					<!-- Powered by -->
					@if (hasStockTerms()) {
						<div class="powered-by-text">{{ "stocks_powered_by" | translate }}</div>
					}
				</div>
			</div>
		}
	}
</div>
